import { FunctionComponent } from 'react';
import { InvoicesLoadingContainer, InvoicesLoadingSpinner } from '../../styled';

const InvoicesTableLoading: FunctionComponent = () => (
    <InvoicesLoadingContainer>
        <InvoicesLoadingSpinner size={32} />
    </InvoicesLoadingContainer>
);

export default InvoicesTableLoading;
